export default __webpack_public_path__ + "static/media/ab-girl.98638972.webp";